import {
	type AnalyticsEventPayload,
	createAndFireEvent,
	type CreateUIAnalyticsEvent,
} from '@atlaskit/analytics-next';
import { TRACK_EVENT_TYPE } from '@atlassian/analytics-bridge';

import { UI_MODIFICATIONS_ANALYTICS_CHANNEL } from '../constants';

export const fireTrackEvent = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	eventPayload: AnalyticsEventPayload,
): void => {
	createAndFireEvent(UI_MODIFICATIONS_ANALYTICS_CHANNEL)({
		...eventPayload,
		analyticsType: TRACK_EVENT_TYPE,
	})(createAnalyticsEvent);
};
